// extracted by mini-css-extract-plugin
export var aircallIframe = "_d5-3";
export var fabContainer = "_d5-5";
export var fabRinging = "_d5-6";
export var loadingOverlay = "_d5-4";
export var pulse = "_d5-7";
export var widgetContent = "_d5-2";
export var widgetPanel = "_d5-0";
export var widgetPanelExpanded = "_d5-1";